import React, {useState} from 'react';
export default function WeatherTemperature(props){
    const [unit, setUnit] = useState("celsius");
    function showFahrenheit(event){
      event.preventDefault();
      setUnit("Fahrenheit");
    }
    function showCelsuis(event){
      event.preventDefault();
      setUnit("celsius");
    }
    if (unit === "celsius") {
    return (
    <span className="WeatherTemperature">
        <span className="temperature">{Math.round(props.celsius)}</span>
        <span className="unit">°C |<a href="/" onClick={showFahrenheit}>°F</a></span>
    </span>
    );
} else {
    let Fahrenheit = (props.celsius* 9/5) +32
    return(
        <span className="WeatherTemperature">
        <span className="temperature">{Math.round(Fahrenheit)}</span>
        <span className="unit"><a href="/" onClick={showCelsuis}>°C</a> |°F</span>
    </span>
    )
}
}